import type { WorklogEvent } from './types';

export function fmtDuration(seconds: number): string {
  if (!seconds || seconds < 0) return '0s';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  if (h) return h + 'h ' + m + 'm';
  if (m) return m + 'm';
  return s + 's';
}

export function eventDate(e: WorklogEvent): Date | null {
  if (e.ntp && e.ntp.utc) {
    const d = new Date(e.ntp.utc);
    if (!isNaN(d.getTime())) return d;
  }
  if (e.local) {
    const d = new Date(e.local);
    if (!isNaN(d.getTime())) return d;
  }
  return null;
}

export function fmtTime(d: Date | null): string {
  if (!d) return '';
  return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export function fmtDate(d: Date | null): string {
  if (!d) return '';
  return d.toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric' });
}

export function stripTag(s: string): string {
  return String(s).replace(/^\[[a-z]+-\d+\]\s*/i, '');
}

export function escapeHtml(s: string): string {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
